module.exports = __webpack_public_path__ + "media/images/ticket/add_to_cart_ov-99c1648f6f7a38e33616a6863d5e8d22.png";